import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <ThemeProvider>
        <AuthProvider>
          <App />
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'var(--bg-card)',
              color: 'var(--text-primary)',
              border: '1px solid var(--border)',
              fontSize: '16px',
              padding: '16px 24px',
              fontWeight: '600',
              fontFamily: 'Inter, sans-serif',
              borderRadius: '16px',
              boxShadow: 'var(--shadow-lg)'
            },
            success: {
              iconTheme: { primary: '#10b981', secondary: 'var(--bg-card)' }
            },
            error: {
              iconTheme: { primary: '#ef4444', secondary: 'var(--bg-card)' }
            }
          }}
        />
        </AuthProvider>
      </ThemeProvider>
    </LanguageProvider>
  </React.StrictMode>
);
